module.exports = __webpack_public_path__ + "static/media/icons_Bilan et suivi LCA - Atelier Physio Sport.10a11557.svg";